<script>
import ResearchHeroSection from "@/components/research/ResearchHeroSection.vue";
import ResearchAboutSection from "@/components/research/ResearchAboutSection.vue";
import ResearchersSection from "@/components/research/ResearchersSection.vue";
import HowToSection from "@/components/common/HowToSection.vue";
import JoinUsSection from "@/components/conference/JoinUsSection.vue";
import { PATHS } from "@/data/nav";

export default {
  name: "ResearchView",
  components: {
    ResearchHeroSection,
    ResearchAboutSection,
    ResearchersSection,
    HowToSection,
    JoinUsSection,
  },
  data() {
    return {
      PATHS,
    };
  },
};
</script>

<template>
  <ResearchHeroSection />

  <ResearchAboutSection />

  <ResearchersSection />

  <JoinUsSection
    :title="$t('home.signUp.title')"
    :text="$t('home.signUp.text')"
    :buttonText="$t('home.signUp.buttonText')"
    :buttonAction="`${PATHS.NEWSLETTER_SIGNUP}`"
  />
  <HowToSection
    title="How to join?"
    text="Become a part of the TRUTH TO JUSTICE Slack-Network to take a stand for truth in the fight against disinformation."
    buttonText="Apply here"
    :buttonAction="PATHS.GET_INVOLVED_FORM"
  />
</template>
